import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
// import reportWebVitals from './reportWebVitals';
import { ThemeProvider as ThemeProviderSC } from "styled-components";
import { theme } from "./Theme";
import { ThemeProvider, responsiveFontSizes } from "@material-ui/core/styles";
ReactDOM.render(
  <React.StrictMode>
    <Router basename={"/"}>
      <ThemeProviderSC theme={theme}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </ThemeProviderSC>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
